import React from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import {useTranslation} from "react-i18next";
import Title from "../../../components/elements/Title";
import MakeBSRequest from "./MakeBSRequest";
import SubTitle from "../../../components/elements/SubTitle";
import {Button} from "@mui/material";
import {ChevronRight} from "lucide-react";
import {Link} from "react-router-dom";


function OrganizationsPage({edit}){
    const { t } = useTranslation();

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={!!edit ? t('viewRequest') : t('makeRequest')}>
            <Grid container spacing={2} justifyContent="center">
                <Grid item size={{xs:12,md:10,lg:10}} >
                    <div className="flex-space mb-20">
                        <SubTitle className="dialog-title " align="left" color="text">{!!edit ? t('viewRequest') : t('makeRequest')}</SubTitle>
                        <Button
                            size="small"
                            color="text"
                            startIcon={<ChevronRight/>}
                            component={Link}
                            to={`/bs-requests/view-all`}
                        >
                            {t('back')}
                        </Button>
                    </div>
                    <MakeBSRequest/>
                </Grid>
            </Grid>
        </AppAnimate>
    );
}
export default withStyles(Styles)(OrganizationsPage);
